/**
 * Table — the WCAG-clean equivalent of a card grid (per the dataviz skill's
 * "table view is the accessibility twin of every chart/grid" rule). Columns
 * declare a `render(row) -> string | Node` so a cell can host a Tag, Badge,
 * or Meter, not just text.
 */
export function Table({ columns, rows }) {
  const table = document.createElement("table");
  table.className = "data-table";

  const thead = document.createElement("thead");
  const headRow = document.createElement("tr");
  for (const col of columns) {
    const th = document.createElement("th");
    th.textContent = col.header;
    if (col.align) th.style.textAlign = col.align;
    headRow.append(th);
  }
  thead.append(headRow);

  const tbody = document.createElement("tbody");
  for (const row of rows) {
    const tr = document.createElement("tr");
    for (const col of columns) {
      const td = document.createElement("td");
      if (col.align) td.style.textAlign = col.align;
      const rendered = col.render ? col.render(row) : String(row[col.key] ?? "");
      if (rendered instanceof Node) td.append(rendered);
      else td.textContent = rendered;
      tr.append(td);
    }
    tbody.append(tr);
  }

  table.append(thead, tbody);

  // Wrapper owns horizontal scroll so a wide table never forces the page
  // to scroll sideways.
  const wrap = document.createElement("div");
  wrap.className = "table-scroll";
  wrap.append(table);
  return wrap;
}
